import React from 'react';
import PropTypes from 'prop-types';
import Field from './field';
import { singularize, wordify } from 'utils';
import { removeModelNamespace } from 'utils/content';

export default class LookupContent extends React.PureComponent {
  static propTypes = {
    lookup: PropTypes.object.isRequired,
    model: PropTypes.string.isRequired,
    query: PropTypes.object,
  };

  state = {};

  constructor(props) {
    super(props);
    this.state = {
      query: this.getQuery(props),
      placeholder: this.getPlaceholder(props),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.query !== this.props.query) {
      this.setState({ query: this.getQuery(this.props) });
    }
  }

  getQuery(props) {
    return {
      ...(props.query || {}),
      fields: 'name, title, published, date_published',
    };
  }

  getPlaceholder(props) {
    return (
      props.placeholder ??
      `Choose ${wordify(
        singularize(removeModelNamespace(props.model)),
      ).toLowerCase()}`
    );
  }

  isUnpublished(record) {
    return !!(
      record.published === false &&
      (!record.date_published || record.date_published < Date.now())
    );
  }

  renderContentValue = (record) => {
    return (
      <span>
        {record.title || record.name || record.id}
        {this.isUnpublished(record) ? (
          <span className="muted"> (Draft)</span>
        ) : (
          <span>&nbsp;</span>
        )}
      </span>
    );
  };

  renderContentLookupItems = ({ lookup, ...props }) => {
    return lookup.results.map((record) => (
      <li
        key={record.id}
        role="option"
        data-id={record.id}
        aria-selected={record.id === props.selected?.id}
        className={`item ${
          record.id === props.selected?.id ? 'selected' : null
        }`}
        onMouseOver={props.onMouseOver}
        onClick={props.onClick}
      >
        <span className="col">{record.title || record.name || record.id}</span>
        {this.isUnpublished(record) ? (
          <span className="col muted"> (Draft)</span>
        ) : (
          <span>&nbsp;</span>
        )}
      </li>
    ));
  };

  render() {
    const { model, lookup, className } = this.props;
    const { query, placeholder } = this.state;
    return (
      <span className={`form-lookup-content ${className || ''}`}>
        <Field
          ref="field"
          type="lookup"
          name={singularize(model)}
          placeholder={placeholder}
          renderValue={this.renderContentValue}
          renderLookupItems={this.renderContentLookupItems}
          model={model}
          query={query}
          lookup={lookup}
          queryFocus={true}
          {...this.props}
          className={undefined}
        />
      </span>
    );
  }
}
